import { SingleStepBody, SingleStepDialog } from "components/SingleStepDialog";
import {
  modalDeleteInProgress,
  modalDeleteInProgressSubtitle,
} from "_constants";

import { ProgressSpinner } from "primereact/progressspinner";

export const ModalDeleteAccountLoading = ({
  showModal,
}: {
  showModal: boolean;
}) => {
  return (
    <SingleStepDialog
      height="353px"
      width="450px"
      header={<></>}
      isDismissable={false}
      body={
        <SingleStepBody
          content={
            <div className="flex-container column width-100 align-center justify-center h-240">
              <div className="spinner-56">
                <ProgressSpinner strokeWidth="4" animationDuration="1s" />
              </div>
              <h3 className="margin-bottom-4">{modalDeleteInProgress}</h3>
              <span>{modalDeleteInProgressSubtitle}</span>
            </div>
          }
        />
      }
      footer={<></>}
      display={showModal}
      setVisible={() => {}}
    />
  );
};
